import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseProjectComponent } from '@layouts/default/layouts/logged/pages/project/components/base-project.component';
import { UntypedFormGroup } from '@angular/forms';
import { Continents } from '@shared/interfaces/project/continents.interface';
import { Config } from '@shared/config';
import { Countries } from '@shared/interfaces/account/countries.interface';
import { Response } from '@shared/models/response.model';
import { Error } from '@shared/interfaces/error.interface';
import { PhFiltersAction, PhFiltersService } from '../../ph-filters.service';
import { PhFiltersDataEmitter } from '@shared/components/ph-filters/ph-filters.service';
import { FiltersParams } from '@shared/models/filters/filters-params.model';
import { PhInputComponent } from '@shared/components/ph-input/ph-input.component';

@Component({
  selector: 'app-filter-continent',
  templateUrl: './filter-continent.component.html',
  styleUrls: ['./filter-continent.component.scss'],
})
export class FilterContinentComponent extends BaseProjectComponent implements OnInit {
  @Input() correctForm: UntypedFormGroup = null;
  continents: Continents[] = Config.CONTINENTS;
  countries: Countries[] = [];
  selectedCountriesLength: number = 0;
  disabled: boolean = false;
  searchable: boolean = true;
  @ViewChild('phInputContinent', { static: true }) phInputContinent: PhInputComponent;

  constructor(public filtersService: PhFiltersService) {
    super();
  }

  ngOnInit() {
    this.correctForm.addControl('filters_country', new UntypedFormGroup({}));
    this.getCountries();
  }

  get continent() {
    return this.correctForm.controls['filters_continent'];
  }

  get country() {
    return this.correctForm.controls['filters_country']['controls'];
  }

  get initCountries() {
    this.selectedCountriesLength = this.filtersService.params.filters_country.length;
    if (
      typeof this.filtersService.params.filters_country === 'string' &&
      this.filtersService.params.filters_country.length > 0
    ) {
      this.selectedCountriesLength = 1;
      return [this.filtersService.params.filters_country];
    }
    return this.filtersService.params.filters_country;
  }

  get initContinent() {
    return this.filtersService.params.filters_continent;
  }

  getCountries() {
    const subCountries = this.accountService
      .allCountriesList()
      .subscribe((res: Response<Countries[]>) => {
        this.countries = res.data;
        setTimeout(this.checkUrlParams.bind(this));
      }, this.onCountriesListError.bind(this));
    this.someSubscriptions.add(subCountries);
  }

  onCountriesListError(error: Error) {
    this.toast.error(
      this.translate.instant('ACCOUNT.countries_cant_get'),
      this.translate.instant('ACCOUNT.countries_error')
    );
  }

  getFiltersCountryParams(selected: boolean = false) {
    let countries = [];

    for (const key in this.country) {
      if (!this.country.hasOwnProperty(key)) {
        continue;
      }
      this.country[key].value ? (countries = this.country[key].value) : null;
    }
    this.selectedCountriesLength = countries.length;
    if (this.selectedCountriesLength >= 10) {
      document.body.click();
      this.searchable = false;
    } else {
      this.searchable = true;
    }
    return { filters_country: countries.length > 0 ? countries : '' };
  }

  updateCountriesParams() {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: this.getFiltersCountryParams(true),
      })
    );
  }

  updateParams() {
    this.filtersService.filtersEmitter.emit(
      new PhFiltersDataEmitter({
        action: PhFiltersAction.UPDATE_PARAMS,
        params: {
          filters_continent: this.continent.value,
          filters_country: '',
          page: 1,
        },
      })
    );
    this.resetCountry();
  }

  updateCountriesArray(): Countries[] {
    if (this.continent.value === '') {
      return this.countries;
    }
    return this.countries.filter((el: Countries) => el.continent === this.continent.value);
  }

  resetCountry() {
    for (const key in this.country) {
      if (!this.country.hasOwnProperty(key)) {
        continue;
      }
      this.country[key].patchValue('', { emitEvent: true });
    }
    this.updateCountriesParams();
  }

  resetContinent() {
    this.continent.setValue('');
    this.phInputContinent.uncheckedAllRadio();
    this.updateParams();
  }

  checkUrlParams() {
    const params: FiltersParams = this.filtersService.params;

    if (params.filters_continent) {
      this.correctForm.controls['filters_continent'].patchValue(params.filters_continent, {
        emitEvent: false,
      });
    }
    if (params.filters_country) {
      this.correctForm.controls['filters_country'].patchValue(params.filters_country, {
        emitEvent: false,
      });
    }
  }
}
